export class BeamError extends Error {
  supportUrl: string;
  constructor(msg?: string, { cause, name = "BeamError" }: { cause?: any; name?: string } = {}) {
    super(msg, { cause });
    this.name = name;
    this.supportUrl = "https://beamimpact.com";
  }
}

export class NetworkError extends BeamError {
  /** Fetch Response object with .ok, .status, etc.*/
  response: Response;
  /** If network response included JSON payload, it is parsed and available here */
  body?: Record<string, string>;
  constructor(response: Response, body?: Record<string, string>, msg?: string) {
    super(msg, { name: "BeamNetworkError" });
    this.response = response;
    this.body = body;
  }
}

export class MissingConfig extends BeamError {
  missingConfigKeyNames: string[];
  constructor(missingConfigKeyNames: string[] = [], msg?: string) {
    super(msg, { name: "BeamMissingConfig" });
    this.missingConfigKeyNames = missingConfigKeyNames;
  }
}

export class InvalidAttributeCombinationError extends BeamError {
  constructor(msg = "Both transactionId and subscriptionId cannot be specified at the same time.") {
    super(msg, { name: "BeamInvalidAttributeCombinationError" });
  }
}

export class LocalStorageError extends BeamError {
  constructor(msg?: string) {
    super(msg, { name: "BeamLocalStorageError" });
  }
}

export class SetupError extends BeamError {
  constructor(msg?: string) {
    super(msg, { name: "BeamSetupError" });
  }
}
